<template>
  <div class="uk-flex uk-flex-center uk-flex-middle uk-background-muted uk-height-viewport">
    <div class="uk-width-medium uk-padding-small">
      <form @submit.prevent="submit">
        <fieldset class="uk-fieldset">
          <legend class="uk-legend">Login</legend>
          <div class="uk-margin">
            <div class="uk-inline uk-width-1-1">
              <span class="uk-form-icon uk-form-icon-flip" data-uk-icon="icon: user"></span>
              <input class="uk-input uk-form-large" required placeholder="Benutzer" type="text" v-model="username">
            </div>
          </div>
          <div class="uk-margin">
            <div class="uk-inline uk-width-1-1">
              <span class="uk-form-icon uk-form-icon-flip" data-uk-icon="icon: lock"></span>
              <input class="uk-input uk-form-large" required placeholder="Passwort" type="password" v-model="password">
            </div>
          </div>

          <div class="uk-margin">
            <button type="submit" 
              class="uk-button uk-button-primary uk-button-primary uk-button-large uk-width-1-1"
              :disabled="sending">
              <div data-uk-spinner v-if="sending"></div>
              Anmelden
            </button>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</template>
<script>
  import { mapActions } from 'vuex'
  import localforage from 'localforage'
  import { isEmpty } from 'lodash'
  export default {
    data () {
      return {
        username: null,
        password: null,
        errors: [],
        sending: false
      }
    },
    mounted() {
      this.$store.commit('SET_LAYOUT', 'login-layout')
    },
    methods: {
      ...mapActions({
        login: 'auth/login'
      }),

      async submit() {
        this.sending = true
        try {
          await this.login({
            payload: {
              username: this.username,
              password: this.password
            },
            context: this
          })
          if(this.$route.query.redirect) {
            this.$router.replace(this.$route.query.redirect);
              return
          }
          
          this.$router.replace({name: 'dashboard'});
        
        } catch(error) {
          console.log(error)
        }
      }
    }
  }
</script>
